import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/fancy-carousel/FancyCarousel.tsx");
